import { useTranslation } from "react-i18next";
import { ButtonNavbar, Menu } from "./MenuService";
import {
  ArrowDropDown,
  ArrowDropUp,
  Logout as LogoutIcon,
  Person as PersonIcon,
  Settings,
  SupervisedUserCircle,
} from "@mui/icons-material";
import { styled, MenuItem, Typography, Box, Stack, Divider } from "@mui/material";
import { useState } from "react";
import ReactGA from "components/ReactGA";
import { useHistory } from "react-router-dom";
import { ListItemIcon } from "@mui/material";
import ProfileUsage from "sections/profile/ProfileUsage";
import LabelPackage from "sections/profile/LabelPackage";
import { selectIsViewUserManagement, selectPermissionFeature } from "redux/slices/role";
import { useSelector } from "redux/store";

type MenuProfile = {
  signOut: () => any;
  profile: {
    username: string;
    email: string;
  };
};

const MenuProfile = ({ signOut, profile }: MenuProfile) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const openAccount = Boolean(anchorEl);
  const handleOpenAccount = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseAccount = () => {
    setAnchorEl(null);
  };

  const isViewUserManagement = useSelector(selectPermissionFeature)("user_management");

  return (
    <>
      <ButtonNavbar
        id="appbar-button-username"
        variant="text"
        startIcon={<SupervisedUserCircle />}
        endIcon={openAccount ? <ArrowDropUp /> : <ArrowDropDown />}
        onClick={handleOpenAccount}
      >
        <Stack direction="row" spacing={1}>
          <Box
            sx={{
              maxWidth: 150,
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
            }}
          >
            {profile?.username}
          </Box>
        </Stack>
      </ButtonNavbar>
      <Menu
        anchorEl={anchorEl}
        open={openAccount}
        onClose={handleCloseAccount}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box sx={{ px: 2, pt: 1 }}>
          <Typography variant="subtitle2">{profile?.username}</Typography>
          <Typography variant="body2" color="text.secondary">
            {profile?.email}
          </Typography>
        </Box>
        <Stack sx={{ px: 2, pt: 1.5, pb: 1 }} spacing={1}>
          <ProfileUsage />
          <Box>
            <LabelPackage />
          </Box>
        </Stack>
        <Divider />
        <MenuItem
          onClick={() => {
            ReactGA.event("click_navigation", {
              component: "navbar",
              link: "profile",
            });
            history.push("/profile");
          }}
        >
          <ListItemIcon>
            <PersonIcon fontSize="small" color="primary" />
          </ListItemIcon>
          {t("profile")}
        </MenuItem>
        {isViewUserManagement && (
          <MenuItem
            onClick={() => {
              ReactGA.event("click_navigation", {
                component: "navbar",
                link: "user-management",
              });
              history.push("/user-management/role");
            }}
          >
            <ListItemIcon>
              <Settings fontSize="small" color="primary" />
            </ListItemIcon>
            {t("setting_role")}
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            signOut();
            ReactGA.event("logout");
          }}
        >
          <ListItemIcon>
            <LogoutIcon fontSize="small" color="primary" />
          </ListItemIcon>
          {t("appbar.logout")}
        </MenuItem>
      </Menu>
    </>
  );
};

export default MenuProfile;
